import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ISearchAppointment } from './search-appointment.model';

@Injectable({ providedIn: 'root' })
export class AppointmentService {
  constructor(private http: HttpClient) {}

  getAppointments(month: string, maxDate: string, token: string): Observable<HttpResponse<ISearchAppointment>> {
    let headers = new HttpHeaders();
    headers = headers.set('token', token);
    return this.http.get<ISearchAppointment>(SERVER_API_URL + 'api/appointment-search/' + month + '/' + maxDate, {
      observe: 'response',
      headers,
    });
  }

  book(appointment: any, token: string, utmSource: string | null): Observable<HttpResponse<any>> {
    let headers = new HttpHeaders();
    headers = headers.set('token', token);
    if (utmSource !== null) {
      headers = headers.set('utmSource', utmSource);
    }
    return this.http.post(SERVER_API_URL + 'api/appointment/book', appointment, {
      observe: 'response',
      headers,
    });
  }

  step2completed(): Observable<HttpResponse<void>> {
    const headers = new HttpHeaders();
    return this.http.get<void>(SERVER_API_URL + 'api/step2completed/', {
      observe: 'response',
      headers,
    });
  }
}
